import React from 'react';
import { useCart } from '../context/CartContext';
import '../App.css';
import '../gutenberg.css';

const products = [
  {
    id: 1,
    name: "OLOVKA ZA OBRVE",
    category: "oči",
    price: 15,
    image: "img/proizvod1.webp"
  },
  {
    id: 2,
    name: "GEL ZA OBRVE",
    category: "oči",
    price: 16,
    image: "img/proizvod2.webp"
  },
  {
    id: 3,
    name: "SET ZA BOJANJE OBRVA",
    category: "oči",
    price: 15,
    image: "img/proizvod3.webp"
  },
  {
    id: 4,
    name: "OLOVKA ZA OBRVE",
    category: "oči",
    price: 30,
    image: "img/proizvod4.webp"
  },
  {
    id: 5,
    name: "KIST ZA OBRVE",
    category: "oči",
    price: 22,
    image: "img/proizvod5.webp"
  },
  {
    id: 6,
    name: "GEL ZA OBRVE",
    category: "oči",
    price: 18,
    image: "img/proizvod6.webp"
  },
  {
    id: 7,
    name: "MASKARA",
    category: "oči",
    price: 15,
    image: "img/proizvod7.webp"
  },
  {
    id: 8,
    name: "BALZAM",
    category: "usne",
    price: 25,
    image: "img/proizvod8.webp"
  }
];

const ProductGrid = () => {
  // Koristi useCart hook za pristup funkcijama košarice
  const { addToCart } = useCart();

  return (
    <div>
      <div className="webshop-naslov">
        <h2>Naši proizvodi</h2>
      </div>
      <section className="webshop">
        <div className="row">
          {products.map((product) => (
            <div className="col-md-4" key={product.id}>
              <div className="proizvod">
                <div className="d-flex like">
                  <a href="#"><h5>{product.name}</h5></a>
                  <a href="#" className="like-full">
                    <img src="img/heart-empty.svg" alt="like" />
                  </a>
                </div>
                <p className="grupa-proizvoda">{product.category}</p>
                <a href="#" className="hover-img">
                  <img src={product.image} alt={product.name} />
                </a>
                <div className="d-flex">
                  <div className="proizvod-cijena">
                    {product.price}<span>eur</span>
                  </div>
                  <div className="proizvod-button">
                    <button
                      className="btn"
                      onClick={() => addToCart(product)}
                    >
                      Dodaj u košaricu
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProductGrid;